import { formatCurrency } from '../../utils/formatCurrency';
import { Button } from '../Button';
import { FooterContent, FooterLeft, FooterTitle, FooterTotal } from './ModalTotalFooter.styles';
import type { ModalTotalFooterProps } from './ModalTotalFooter.types';

export function ModalTotalFooter({
  title,
  totalLabel = 'Total',
  totalAmount,
  currencyCode,
  locale = 'en-GB',
  confirmLabel = 'Confirm',
  onConfirm,
  confirmDisabled = false,
}: ModalTotalFooterProps) {
  return (
    <FooterContent>
      <FooterLeft>
        {title && <FooterTitle>{title}</FooterTitle>}
        <FooterTotal>
          {totalLabel} {formatCurrency(totalAmount, currencyCode, { locale })}
        </FooterTotal>
      </FooterLeft>
      <Button variant="primary" size="large" onClick={onConfirm} disabled={confirmDisabled}>
        {confirmLabel}
      </Button>
    </FooterContent>
  );
}
